import React, { Component } from "react";
import AppDynamicFilterModal from "../../../partials/AppDynamicFilterModal";

export class PendingApplicationSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        page: 1,
      },
      openDrawer: false,
    };
    this.fields = [
      {
        name: "customerName",
        label: "Name",
        type: "text",
        placeholder: "Customer Name",
      },
      {
        label: "Application Date",
        name: "applicationDate",
        type: "date",
        placeholder: "Please Enter",
      },
      {
        name: "customerApplicationType",
        label: "Customer Type",
        type: "select",
        options: _enum.CUSTOMER_TYPES,
      },
      {
        name: "loanAmount",
        label: "Applied Loan Amount",
        type: "text",
      },
      {
        label: "Application Status",
        name: "status",
        type: "select",
        options: _enum.APPLICATION_STATUS,
        placeholder: "Please Enter",
      },
    ];
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { openDrawer } = this.state;
    return (
      <div className="d-flex align-items-center justify-content-end">
        <button
          type="button"
          className="btn filter_modal_btn"
          onClick={(...args) => this.toggleDrawer(...args)}
        >
          <i class="fa-solid fa-filter me-2"></i>
          <span>Filters</span>
        </button>
        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          fields={this.fields}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </div>
    );
  }
}

export default constore(PendingApplicationSearch);
